import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError, timer } from 'rxjs';
import { catchError, delayWhen, retryWhen, scan } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '../translate/translate.service';

const MAX_RETRIES = 3;
const RETRY_DELAYS_MS = [5_000, 15_000, 30_000];

@Injectable()
export class ResilienceInterceptor implements HttpInterceptor {

  constructor(
    private _toastr: ToastrService,
    private _translate: TranslateService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.method === 'GET') {
      return next.handle(req).pipe(
        retryWhen(errors =>
          errors.pipe(
            scan((retryCount: number, error: HttpErrorResponse) => {
              if (retryCount >= MAX_RETRIES || error.status < 500) {
                throw error;
              }
              return retryCount + 1;
            }, 0),
            delayWhen((retryCount: number) => timer(RETRY_DELAYS_MS[retryCount - 1]))
          )
        )
      );
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status >= 500 && !req.headers.has('X-Skip-Error-Toast')) {
          this._toastr.error(this._translate.data['common.serverError'] || 'Server error. Please try again later.');
        }
        return throwError(() => error);
      })
    );
  }
}
